import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISCMShopDetail, ISCMShopSearchFields, shopService, ISCMShopFormFields, ISCMShopInsert, ISCMShopUpdate } from "./shopService";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM, defaultMdCmParam } from "@/utils/constants";
import { ITreeData } from "../../base/dict/dictModel";
import { IMdOrgDetail } from "../org/orgService";
import { OptionDsType, ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "../app/appModel";
import { globalPrompt } from "@/components/YhMessage";
import { message } from "antd";

interface ISCmShopDrawerType {
    visible: boolean,
    mode: "add" | "edit"
}

export const useShopModel = createModel(function () {
    // const { shopLoadDataAll } = useGlobalModel();
    //列表数据源
    const [dataSource, setDataSource] = useState<ISCMShopDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ISCMShopSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);

    //缓存数据
    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>([]);
    const [shopTypeDs, setShopTypeDs] = useState<OptionDsType[]>([]);
    const [beDs, setBeDs] = useState<OptionDsType[]>([]);

    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ISCMShopSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            sourceApp: defaultMdCmParam.sourceApp,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await shopService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ISCMShopSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    const clearSelectData = () => {
        setSelectedRowKeys([]);
    }
    const syncData = async () => {
        let ret = await shopService.sync({});
        ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
        ret && await loadData();
        return ret.retData;
    }
    /**
     * 详情
     */
    const initShopDrawer: ISCmShopDrawerType = { visible: false, mode: "add" }
    const [shopDrawer, setShopDrawer] = useState<ISCmShopDrawerType>(initShopDrawer);
    const setIShopDrawer = (str?: "add" | "edit") => setShopDrawer(str ? { visible: true, mode: str } : initShopDrawer);

    //根据id查询
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? { ...filters[0], status: !!!filters[0]?.status, details: filters[0]?.details?.map(item => item.bentityCode) ?? [] } : null;
    };

    const insertShop = async (val: ISCMShopInsert) => {
        let { retData } = await shopService.insert(val);
        if (retData) {
            loadData();
            setIShopDrawer();
            // shopLoadDataAll();
            globalPrompt("message", { text: "门店新增成功", type: "success" })
        } else {
            globalPrompt("message", { text: "门店新增失败", type: "error" });
        }
    }

    //表单编辑 Api
    const editShop = async (val: ISCMShopInsert) => {
        let { retData } = await shopService.update({ ...val, id: selectedRowKeys[0] });
        if (retData) {
            loadData();
            setIShopDrawer();
            // shopLoadDataAll();
            globalPrompt("message", { text: "门店修改成功", type: "success" })
        } else {
            globalPrompt("message", { text: "门店修改失败", type: "error" });
        }
    }

    //启用 禁用 api
    const disableShop = async (id: string, status: number) => {
        let { retData } = await shopService.disable(id, status);
        retData ?
            loadData() && globalPrompt("message", { text: "操作成功", type: "success" })
            : globalPrompt("message", { text: "操作失败", type: "error" });
    };

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        /***method***/
        shopDrawer, setIShopDrawer,
        orgDs, setOrgDs,
        beDs, setBeDs,
        shopTypeDs, setShopTypeDs,
        getSelectedRowData,
        insertShop,
        editShop,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        disableShop,
        syncData
    }
});